"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = require("../../proptypes/hotel/index");
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _QuantityStatus = _interopRequireDefault(require("./QuantityStatus"));
var COLOR_MAP = new Map([['lots', 'var(--black)'], ['medium', 'var(--black)'], ['few', 'var(--secondary)'], ['n/a', 'var(--secondary)']]);
var POSITION = {
  center: 'justify-content: center; text-align: center;',
  left: 'justify-content: flex-start; text-align: left;',
  right: 'justify-content: flex-end; text-align: end;'
};
var TourQuantity = /*#__PURE__*/_react["default"].memo(function (props) {
  var availability = props.availability,
    withTooltip = props.withTooltip,
    className = props.className,
    text = props.text,
    position = props.position,
    marginTop = props.marginTop,
    marginBottom = props.marginBottom,
    isMobile = props.isMobile,
    maxWidth = props.maxWidth,
    isHotelOnly = props.isHotelOnly,
    _props$isPlusShown = props.isPlusShown,
    isPlusShown = _props$isPlusShown === void 0 ? false : _props$isPlusShown,
    _props$isPackageCheck = props.isPackageCheckout,
    isPackageCheckout = _props$isPackageCheck === void 0 ? false : _props$isPackageCheck;
  if (!availability) return null;
  var _availability$hotel = availability.hotel,
    hotel = _availability$hotel === void 0 ? undefined : _availability$hotel,
    _availability$flight = availability.flight,
    flight = _availability$flight === void 0 ? undefined : _availability$flight,
    tooltip = availability.tooltip;
  var width = 0;
  var color = '';
  var style = {
    position: position,
    marginTop: marginTop,
    marginBottom: marginBottom,
    isMobile: isMobile
  };
  var quantity = [];
  var svgIds = [];
  if (hotel) {
    quantity.push(hotel);
    svgIds.push('hotel');
    width += 0.5;
    color = COLOR_MAP.get(hotel);
  }
  if (!isHotelOnly && flight) {
    quantity.push(flight);
    svgIds.push('plane');
    width += 0.5;
    color = COLOR_MAP.get(flight);
  }
  var component = /*#__PURE__*/_react["default"].createElement(StyledContainer, style, !isPackageCheckout && /*#__PURE__*/_react["default"].createElement(StyledTourQuantity, {
    className: className,
    width: width
  }, !isHotelOnly && flight && hotel && isPlusShown && /*#__PURE__*/_react["default"].createElement(StyledPlus, null, "+"), quantity.length > 0 && /*#__PURE__*/_react["default"].createElement(_QuantityStatus["default"], {
    quantity: quantity,
    svgIds: svgIds,
    width: width,
    isPlusShown: isPlusShown
  })), text && /*#__PURE__*/_react["default"].createElement(StyledText, {
    maxWidth: maxWidth,
    color: color,
    isMobile: isMobile
  }, text));
  return withTooltip ? /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    text: tooltip
  }, component) : component;
});
TourQuantity.displayName = 'TourQuantity';
TourQuantity.propTypes = {
  availability: _index.AvailabilityPropTypes.isRequired,
  text: _propTypes["default"].string,
  position: _propTypes["default"].oneOf(Object.keys(POSITION)),
  className: _propTypes["default"].string,
  withTooltip: _propTypes["default"].bool,
  marginTop: _propTypes["default"].number,
  marginBottom: _propTypes["default"].number,
  isMobile: _propTypes["default"].bool,
  maxWidth: _propTypes["default"].string
};
TourQuantity.defaultProps = {
  position: 'left',
  text: '',
  className: '',
  marginTop: 0,
  marginBottom: 0,
  withTooltip: true,
  isMobile: false,
  maxWidth: '100%'
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "TourQuantity__StyledContainer",
  componentId: "sc-16riljq-0"
})(["display:flex;flex-direction:row;", ";margin-bottom:", "px;margin-top:", "px;align-items:", ";"], function (_ref) {
  var position = _ref.position;
  return POSITION[position];
}, function (_ref2) {
  var marginBottom = _ref2.marginBottom;
  return marginBottom;
}, function (_ref3) {
  var marginTop = _ref3.marginTop;
  return marginTop;
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? 'center' : 'inherit';
});
var StyledTourQuantity = _styledComponents["default"].div.withConfig({
  displayName: "TourQuantity__StyledTourQuantity",
  componentId: "sc-16riljq-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;width:", "px;height:16px;position:relative;svg{stroke-width:1;}"], function (_ref5) {
  var width = _ref5.width;
  return width * 66;
});
var StyledText = _styledComponents["default"].span.withConfig({
  displayName: "TourQuantity__StyledText",
  componentId: "sc-16riljq-2"
})(["color:", ";max-width:", ";"], function (_ref6) {
  var color = _ref6.color;
  return color;
}, function (_ref7) {
  var maxWidth = _ref7.maxWidth;
  return maxWidth;
});
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "TourQuantity__StyledBubble",
  componentId: "sc-16riljq-3"
})(["width:", "px;height:16px;cursor:pointer;position:relative;vertical-align:bottom;"], function (_ref8) {
  var width = _ref8.width;
  return width * 36;
});
var StyledPlus = _styledComponents["default"].div.withConfig({
  displayName: "TourQuantity__StyledPlus",
  componentId: "sc-16riljq-4"
})(["color:#919499;transform:translate(28px,0px);"]);
var _default = exports["default"] = TourQuantity;